const DB_NAME = "erp-db";
let DB_VERSION;
let DB;
let newTables = [];

export default {
  async getDb() {
    return new Promise((resolve, reject) => {
      if (DB) {
        return resolve(DB);
      }
      let request;
      if (DB_VERSION) {
        request = window.indexedDB.open(DB_NAME, DB_VERSION);
      } else {
        request = window.indexedDB.open(DB_NAME);
      }
      request.onerror = (e) => {
        console.error("Error opening db", e);
        reject("Error");
      };

      request.onsuccess = (e) => {
        DB = e.target.result;
        if (!DB_VERSION) {
          DB_VERSION = DB.version;
        }
        resolve(DB);
      };

      request.onupgradeneeded = (e) => {
        let db = e.target.result;
        newTables.forEach((t) => {
          if (!db.objectStoreNames.contains(t)) {
            db.createObjectStore(t, { keyPath: "id" });
          }
        });
      };
    });
  },
  async gets(table) {
    let db = await this.getDb();
    return new Promise((resolve) => {
      let trans = db.transaction([table], "readonly");
      trans.oncomplete = () => {
        resolve(items);
      };
      let store = trans.objectStore(table);
      let items = [];

      store.openCursor().onsuccess = (e) => {
        let cursor = e.target.result;
        if (cursor) {
          items.push(cursor.value);
          cursor.continue();
        }
      };
    });
  },
  async register(table, items) {
    let db = await this.getDb();
    return new Promise((resolve) => {
      let trans = db.transaction([table], "readwrite");
      trans.oncomplete = () => {
        resolve();
      };
      let store = trans.objectStore(table);
      items.forEach((item) => {
        store.put(item);
      });
    });
  },
  async save(table, item) {
    let db = await this.getDb();
    return new Promise((resolve) => {
      let trans = db.transaction([table], "readwrite");
      trans.oncomplete = () => {
        resolve();
      };
      let store = trans.objectStore(table);
      store.put(item);
    });
  },
  async delete(table, itemId) {
    let db = await this.getDb();
    return new Promise((resolve) => {
      let trans = db.transaction([table], "readwrite");
      trans.oncomplete = () => {
        resolve();
      };
      let store = trans.objectStore(table);
      store.delete(itemId);
      // store.delete(item.id);
    });
  },
  async clear(table) {
    let db = await this.getDb();
    return new Promise((resolve) => {
      let trans = db.transaction([table], "readwrite");
      trans.oncomplete = () => {
        resolve();
      };
      trans.onerror = () => {};
      let store = trans.objectStore(table);
      store.clear();
    });
  },
  async checkTable(tables) {
    let db = await this.getDb();
    return new Promise((resolve) => {
      tables.forEach((table) => {
        if (!db.objectStoreNames.contains(table)) {
          newTables.push(table);
        }
      });
      if (newTables.length > 0) {
        DB_VERSION++;
        db.close();
        DB = null;
        this.getDb();
      }
      resolve();
    });
  },
};
